/*
 * PRD-037 — Alias de compatibilidad del flujo suelto "Cargar menú".
 *
 * El menú dejó de ser un flujo separado: ahora es el paso [6 Menú] del wizard UNIFICADO "Preparar
 * comercio". Este componente preserva el deep-link `/partner/draft/:id/menu` (links viejos, atajos)
 * redirigiéndolo al wizard abierto directamente en el paso de menú (`?step=menu`). El gate de sesión
 * (DraftGate en PartnerApp) ya garantiza que solo se monte con sesión de partner.
 */
import { Navigate, useParams } from 'react-router-dom';

const PartnerDraftMenu = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/partner/draft/${id}/configurar?step=menu`} replace />;
};

export default PartnerDraftMenu;
